import './index.scss'
import { BeatLoader } from 'react-spinners';

const Button = (props) => (
    <button type="button" className='button ' {...props}>
      {props.isLoading ? <label className='button__loader'>LOADING<BeatLoader
        className='spinner'
        color="#36d7b7"
        size={10}
      /> </label>: <label >{props.label.toUpperCase()}</label>}
    </button>
)

export default Button;